import React, { Component } from "react";
import * as FlexLayout from "flexlayout-react";
import Commodities from "./commodities";
import Commodity from "./commodity";
import { withTranslation } from "react-i18next";

class CommodityAdmin extends Component {
  LAYOUT = {
    global: {
      minWidth: 100,
      minHeight: 100,
    },
    borders: [],
    layout: {
      type: "row",
      children: [
        {
          type: "tabset",
          weight: 50,
          enableMaximize: false,
          children: [
            {
              type: "tab",
              name: this.props.t("Commodities"),
              enableClose: false,
              component: "Commodities",
            },
          ],
        },
        {
          //Figure out how to make this persistent even when empty.
          type: "tabset",
          id: "1",
          weight: 50,
          enableDeleteWhenEmpty: false,
          enableMaximize: false,
          children: [
            // {
            //   type: "tab",
            //   name: "User",
            //   visible: false,
            //   component: "Placeholder"
            // }
          ],
        },
      ],
    },
  };

  state = {
    model: FlexLayout.Model.fromJson(this.LAYOUT),
  };

  handleCommoditySelect = (Commodity, submitCallbackFunction, isNew) => {
    const { commodityId, name } = Commodity;

    try {
      this.state.model.doAction(
        FlexLayout.Actions.addNode(
          {
            type: "tab",
            component: "Commodity",
            name: `${name}`,
            id: `${commodityId}`,
            config: { commodityId, submitCallbackFunction, isNew },
          },
          "1",
          FlexLayout.DockLocation.CENTER,
          0,
          true
        )
      );
    } catch {
      this.state.model.doAction(FlexLayout.Actions.selectTab(commodityId));
    }
  };

  handleTabRename = (nodeId, name) => {
    this.state.model.doAction(
      FlexLayout.Actions.updateNodeAttributes(nodeId, { name: name })
    );
  };

  factory = (node) => {
    const componentId = node.getComponent();
    //const CommodityId = node.getId();

    if (componentId === "Commodities") {
      return (
        <Commodities
          onClick={this.handleCommoditySelect}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "Commodity") {
      const { commodityId, submitCallbackFunction, isNew } = node.getConfig();
      return (
        <Commodity
          commodityId={commodityId}
          submitCallbackFunction={submitCallbackFunction}
          isNew={isNew}
          onRename={this.handleTabRename}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "Placeholder") {
      return <div></div>;
    } else {
      return null;
    }
  };

  buildFlexLayout = () => {
    return (
      <div className="flex-container">
        <FlexLayout.Layout model={this.state.model} factory={this.factory} />;
      </div>
    );
  };

  render() {
    return this.buildFlexLayout();
  }
}

export default withTranslation(["products"])(CommodityAdmin);
